module.exports = __webpack_public_path__ + "static/media/hoops_icon.52ba7528.svg";